import type { AuthSession } from "@/features/auth/model/auth-session";
import { platformHttpClient } from "@/shared/api/platform-http-client";

export const AUTH_SESSION_QUERY_KEY = ["authSession"] as const;

export async function fetchAuthSession(): Promise<AuthSession> {
  const response = await platformHttpClient.get<AuthSession>("/v1/me");
  return response;
}
